import type {FC} from 'react';
import {MdArrowForwardIos} from 'react-icons/md';
import {CommonLink} from '../../../../../shared/components/CommonLink';

export const Title: FC<{
  detailLink?: string;
  title: string;
}> = ({detailLink, title}) => {
  if (detailLink) {
    return (
      <CommonLink href={detailLink} className="hover:opacity-60">
        <h2 className="text-[16px] pc:text-[20px] font-bold leading pc:leading-[1.1] inline-flex items-center gap-4">
          {title} <MdArrowForwardIos />
        </h2>
      </CommonLink>
    );
  }
  return (
    <h2 className="text-[16px] pc:text-[20px] font-bold leading pc:leading-[1.1] inline-flex items-center gap-4">
      {title}
    </h2>
  );
};
